import { render, staticRenderFns } from "./SourceTypeSelectionItem.vue?vue&type=template&id=13c66f02&scoped=true"
import script from "./SourceTypeSelectionItem.vue?vue&type=script&lang=js"
export * from "./SourceTypeSelectionItem.vue?vue&type=script&lang=js"
import style0 from "./SourceTypeSelectionItem.vue?vue&type=style&index=0&id=13c66f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c66f02",
  null
  
)

export default component.exports